/**
 * Public barrel export for ScoreFilterSections.
 * @module features/scouting/components/MobileFilterSheet/ScoreFilterSections
 */
export { default } from "./ScoreFilterSectionsView";
